module.exports = __webpack_public_path__ + "media/application/images/svgs/align-right-2fc67197c7d0a1f63ce806dfb6ff5df4.svg";